import Welcome from "@/views/admin/dashboard/Welcome.vue";

export default {
  path: "",
  component: Welcome,
  name: "welcome"
};
